<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed right-0 left-0 shadow overflow-y-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.mdMax:bottom-0]="keyboardOffset === 0"
>
  @if (isDesktop()) {
    <app-modal-filler-atom
      [withBackdrop]="false"
      (onClick)="close()"
      [index]="(index$ | async) ?? 0"
    ></app-modal-filler-atom>
  }
  <div
    class="md:min-w-448 p-5 md:p-7 rounded-t-3xl md:rounded-3xl md:max-w-lg md:w-2/5" [style.backgroundColor]="backgroundColor | contentBuilderColor: '#FFFFFF'"
    [style.z-index]="((index$ | async) ?? 0) + 50"
  >
    @if (step === 'attach-with-email') {
      <app-como-create-or-link-account-modal-attach-with-email-step
        (goToStep)="goToStep($event)"
      ></app-como-create-or-link-account-modal-attach-with-email-step>
    }

    @if (step === 'identification') {
      <app-como-create-or-link-account-modal-identification-step
        [comoPlugin]="comoPlugin"
        (goToStep)="goToStep($event)"
        (setPhoneOrEmail)="setPhoneOrEmail($event)"
        (onClose)="close()"
      ></app-como-create-or-link-account-modal-identification-step>
    }

    @if (step === 'otp') {
      <app-como-create-or-link-account-modal-otp-step
        [phoneOrEmail]="phoneOrEmail"
        (goToStep)="goToStep($event)"
        (close)="close()"
      ></app-como-create-or-link-account-modal-otp-step>
    }

    @if (step === 'registration') {
      <app-como-create-or-link-account-modal-registration-step
        [comoPlugin]="comoPlugin"
        [phoneOrEmail]="phoneOrEmail"
        (goToStep)="goToStep($event)"
        (close)="close()"
      ></app-como-create-or-link-account-modal-registration-step>
    }
  </div>
</div>
